import { BorderColors, BorderRadius } from "@abel-technologies-as/components";
import styled from "styled-components";

const LocaleEditorWrapper = styled.form`
	width: 100%;
	padding: 24px;
	border: 1px solid ${BorderColors.Secondary};
	border-radius: ${BorderRadius.LG}px;
`;

const TextAreaFormWrapper = styled.div`
	margin-top: 12px;
	margin-bottom: 20px;
`;

const DeleteBtn = styled.button`
	background-color: transparent;
	outline: none;
	color: transparent;
	cursor: pointer;
	border: 0;
`;

export { LocaleEditorWrapper, TextAreaFormWrapper, DeleteBtn };
